import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Avatar from './Avatar';
import Like from './Like';
import Content from './Content';
import Footer from './Footer';
import SubComment from './SubComment';
import More from './More';
import { POSITION_MAIN } from '../constants';

const Comment = ({ content, position, allowComment }) => {
    const {
        id,
        comment,
        commentUserImgSrc: avatar,
        commentUserName: userName,
        userLikeStatus,
        likeCount,
        subjectId,
        replyUser,
        checkStatus,
        updateTime,
        createTime,
        hideExtra,
        commentUserId,
        rootId,
        comments,
        commentCount,
    } = content;

    return (
        <div className={styles.wrap}>
            <div className={styles.comment}>
                <div className={styles.commentLeft}>
                    <Avatar link={avatar} />
                </div>
                <div className={styles.commentRight}>
                    <div className={styles.header}>
                        <div className={styles.userName}>{userName}</div>
                        <Like
                            like={userLikeStatus === 1}
                            count={likeCount}
                            subjectId={subjectId}
                            commentId={id}
                            position={position}
                        />
                    </div>
                    <Content content={{ comment, replyUser, checkStatus }} />
                    <Footer
                        content={{
                            updateTime,
                            createTime,
                            hideExtra,
                            commentUserId,
                            subjectId,
                            commentId: id,
                            comment,
                            userName,
                            rootId,
                            position,
                            allowComment,
                        }}
                    />
                    {position === POSITION_MAIN ? (
                        <>
                            {comments && Array.isArray(comments) && comments.length ? (
                                <div>
                                    {comments
                                        .slice(0, 2)
                                        .map(item => (
                                            <SubComment
                                                content={item}
                                                position={position}
                                                key={item.id}
                                                allowComment={allowComment}
                                            />
                                        ))}
                                </div>
                            ) : null}
                            {comments && Array.isArray(comments) && commentCount > 2 ? (
                                <More id={id} content={{ commentCount }} />
                            ) : null}
                        </>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

Comment.propTypes = {
    content: PropTypes.object,
    position: PropTypes.string,
    allowComment: PropTypes.bool,
};

export default errorBoundary(Comment);
